import { createApp } from 'vue'
import App from './App.vue'
import store from '@/store'
import { Image as VanImage, Lazyload } from 'vant'
import { fs_main } from '@/utils/app'
import directive from "@/utils/directive"
window.fs_main = fs_main
const app = createApp(App).use(store).use(VanImage).use(Lazyload)
// 微信公众号开放标签-自定义指令

app.use(directive);
app.mount('#app')